import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UserDetailPage } from './user-detail.page';
import { UserPhotoPageModule } from '../components/user-photo/user-photo.module';
import { UserObjectPageModule } from '../components/user-object/user-object.module';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: '',
        component: UserDetailPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        UserPhotoPageModule,
        UserObjectPageModule,
        TranslateModule
    ],
    declarations: [UserDetailPage]
})
export class UserDetailPageModule {}
